import { render, staticRenderFns } from "./pageOne.vue?vue&type=template&id=24abdb7a&scoped=true&"
import script from "./pageOne.vue?vue&type=script&lang=js&"
export * from "./pageOne.vue?vue&type=script&lang=js&"
import style0 from "./pageOne.vue?vue&type=style&index=0&id=24abdb7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24abdb7a",
  null
  
)

export default component.exports